import { QueryObserverResult } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { CollapsibleSection } from '../../../../../react-commons/components/data-display/CollapsibleSection';
import { Section } from '../../../../../react-commons/components/data-display/Section';
import { ControlledInputs } from '../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import { DetailedValidationResource } from '../../../resource/resources/validation/detailedValidationResource';
import { LoadingComponent } from '../LoadingComponent';
import { ResourceDetailsButton } from '../validation/ResourceDetailsButton';

export const NonCollapsibleQueryStateComponent = ({
    label,
    resourceType,
    children,
    handleEditClick,
    handleAddClick,
    handleDeleteClick,
    setState,
    query,
    validationResource,
}: {
    children: React.ReactNode | React.ReactNode[];
    resourceType: ResourceType | ResourceType[];
    label: string;
    readOnly: boolean; // TODO use or remove
    handleEditClick?: () => void;
    handleAddClick?: () => void;
    handleDeleteClick?: () => void;
    setState?: React.Dispatch<React.SetStateAction<any>>;
    validationResource: DetailedValidationResource | undefined;
    query: QueryObserverResult<any>;
}) => {
    useEffect(() => {
        if (query.data && setState) {
            setState(query.data);
        }
    }, [query.data]);

    const content = () => {
        if (query.data) {
            return (
                <Section
                    label={label}
                    handleEditClick={handleEditClick}
                    handleDeleteClick={handleDeleteClick}
                    rightLabelBarNode={
                        <ResourceDetailsButton
                            resourceValidationResult={validationResource}
                            resourceType={resourceType}
                        />
                    }
                >
                    {children}
                </Section>
            );
        } else {
            return (
                <Section
                    label={label}
                    handleAddClick={handleAddClick}
                    rightLabelBarNode={
                        <ResourceDetailsButton
                            resourceValidationResult={validationResource}
                            resourceType={resourceType}
                        />
                    }
                />
            );
        }
    };

    return (
        <>
            {query.error ?
                <CollapsibleSection label={label} initialOpen={true}>
                    <ControlledInputs.String
                        nullable={false}
                        value={`Error! ${label} could not be fetched!`}
                        readOnly={true}
                    />
                </CollapsibleSection>
            : query.data ?
                content()
            : query.isLoading ?
                <LoadingComponent />
            :   <Section
                    label={label}
                    handleAddClick={handleAddClick}
                    rightLabelBarNode={
                        <ResourceDetailsButton
                            resourceValidationResult={validationResource}
                            resourceType={resourceType}
                        />
                    }
                />
            }
        </>
    );
};
